import ITenantConfig from '../../interfaces/ITenantConfig';

export const TENANT_REQUEST = 'tenant/REQUEST';
export const TENANT_RESOLVE = 'tenant/RESOLVE';
export const TENANT_REJECT = 'tenant/REJECT';

export const requestTenant = () => ({ type: TENANT_REQUEST });
export const resolveTenant = (config: ITenantConfig) => ({ type: TENANT_RESOLVE, payload: config });
export const rejectTenant = (error: Error) => ({ type: TENANT_REJECT, payload: error.message });
